import { render, staticRenderFns } from "./Details.vue?vue&type=template&id=199f5c20&scoped=true&"
import script from "./Details.vue?vue&type=script&lang=js&"
export * from "./Details.vue?vue&type=script&lang=js&"
import style0 from "./Details.vue?vue&type=style&index=0&id=199f5c20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "199f5c20",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('199f5c20')) {
      api.createRecord('199f5c20', component.options)
    } else {
      api.reload('199f5c20', component.options)
    }
    module.hot.accept("./Details.vue?vue&type=template&id=199f5c20&scoped=true&", function () {
      api.rerender('199f5c20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/serviceDetails/Details.vue"
export default component.exports